import { LabelRoleSize, LabelRoleType } from '../../../../types/common.types';

export interface IconLabel {
  iconPath: string;
  title: string;
  role: LabelRoleType;
  size: LabelRoleSize;
}

export interface VisibilityConfig {
  visible: boolean;
}
